import { render, staticRenderFns } from "./ServicesHeader.vue?vue&type=template&id=80172ea6&"
import script from "./ServicesHeader.vue?vue&type=script&lang=js&"
export * from "./ServicesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports